import Honeypot from 'mrg-smokescreen/Honeypot';

function detect(cfg) {
    var enabled = cfg.honeypotEnabled || false;

    if (!enabled) {
        return Promise.resolve(false);
    }

    var rules    = cfg.honeypotRules || ['.dialogWrapperBanner'];
    var cssRules = cfg.honeypotCssRules || ['position: relative'];
    var jsConfig = cfg.honeypotJsConfig || null;

    return Honeypot.check(rules, cssRules, jsConfig);
}

export default detect;
